export const getLocalStorageUser = () => {
  const stringUser = localStorage.getItem("user");
  let user = [];

  try {
    user = JSON.parse(stringUser);
  } catch (e) {}
  return user instanceof Object ? user : {};
};

export const getLocalStorageAuth = () => {
  let auth = {};

  try {
    const stringAuth = localStorage.getItem("auth");
    auth = JSON.parse(stringAuth);
  } catch (e) {}
  return typeof auth === "object" ? auth : {};
};

export const setLocalStorageAuth = auth => {
  try {
    if (typeof auth === "object") {
      localStorage.setItem("auth", JSON.stringify(auth));
      return auth;
    }
    if (auth == null) {
      localStorage.removeItem("auth");
    }
  } catch (e) {}
};

export const setLocalStorageCookie = cookie_auth => {
  if (cookie_auth && typeof cookie_auth == "object") {
    localStorage.setItem("cookie_auth", JSON.stringify(cookie_auth));
    return cookie_auth;
  }
  if (cookie_auth == null) {
    localStorage.removeItem("cookie_auth");
  }
};

export const getLocalStorageCoda = () => {
  const stringCoda = localStorage.getItem("coda");
  let coda = {};

  try {
    coda = JSON.parse(stringCoda);
  } catch (e) {}
  return typeof coda === "object" ? coda : {};
};

export const setLocalStorageCoda = coda => {
  if (typeof coda === "object") {
    localStorage.setItem("coda", JSON.stringify(coda));
    return coda;
  }
  if (coda == null) {
    localStorage.removeItem("coda");
  }
};

export const getLocalStorageOrder = () => {
  const stringOrder = localStorage.getItem("order");
  let order = {};

  try {
    order = JSON.parse(stringOrder);
  } catch (e) {}
  return typeof order === "object" ? order : {};
};

export const setLocalStorageOrder = order => {
  if (typeof order === "object") {
    localStorage.setItem("order", JSON.stringify(order));
    return order;
  }
  if (order == null) {
    localStorage.removeItem("order");
  }
};

export const getCreditNoteRedirectStorage = () => {
  return localStorage.getItem("payment_redirect_url");
};

export const setCreditNoteRedirectStorage = uri => {
  if (uri) {
    localStorage.setItem("payment_redirect_url", uri);
    return uri;
  }
  localStorage.removeItem("payment_redirect_url");
};

export const getSubscriptionsRedirectStorage = () => {
  return localStorage.getItem("payment_redirect_url");
};

export const setSubscriptionsRedirectStorage = uri => {
  if (uri) {
    localStorage.setItem("payment_redirect_url", uri);
    return uri;
  }
  localStorage.removeItem("payment_redirect_url");
};



// WEBPACK FOOTER //
// ./app/api/PaymentAPI.js